export const userCredentialsMutationKeys = {
	updatePassword: ['userCredentials', 'updatePassword'],
};
